// Styles
import './ZergRushBanner.scss';

// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ZergRushBannerDefaultProps,
  ZergRushBannerPropTypes,
} from './ZergRushBanner.protypes';

const ZergRushBanner = ({ message, reason }) => {
  const { t } = useTranslation();

  return (
    <div
      id="zerg-rush-banner"
      className="zerg-rush-banner"
      data-qa-id="zerg-rush-banner"
      data-qa-reason={reason}
    >
      <div className="message" data-qa-id="message">
        {message || t('common:messages:zerg_rush.general.banner')}
      </div>
    </div>
  );
};

ZergRushBanner.defaultProps = {
  ...ZergRushBannerDefaultProps,
};

ZergRushBanner.propTypes = {
  ...ZergRushBannerPropTypes,
};

export default ZergRushBanner;
